import { Box, Grid } from '@mui/material'
import {createContext, useEffect,useState} from 'react'
import { BannerServices } from '../BannerServices'
import Swal from 'sweetalert2'
// import CustomerAppSlider from './CustomerAppSlider'
import SliderList from './SliderList'
import Loading from '../../../../components/Loader/Loading'
import ExpertAppSlider from './ExpertAppSlider'

const ExpertBannerContext = createContext();
const ExpertBanners = () => {
    const [allRowCount, setAllRowCount] = useState(0);
    const [list, setList] = useState([]);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
        filters: {
        searchKey: "",
        sortBy:'createdAt',
        sortType:'desc',
        filterOptions: [
        {
          "fieldName": "platformName",
          "operator": "equals",
          "value": "SE-App"
        },
        {
          "fieldName": "bannerCategory",
          "operator": "equals",
          "value": "Homescreen",
          "andOr": "and"
        },
        {
          "fieldName": "isSlider",
          "operator": "equals",
          "value": "true",
          "andOr": "and"
        },
        // {
        //   "fieldName": "status",
        //   "operator": "equals",
        //   "value": "active",
        //   "andOr": "and"
        // },
        {
          "fieldName": "isExpired",
          "operator": "equals",
          "value": "false",
          "andOr": "and"
        }
      ]
    }
    });
    const [loading, setLoading] = useState(false);
    const fetchBannerList = async ()=>{
    try {
        setLoading(true)
        const listResponse = await BannerServices.bannerList({
        page: paginationModel.page,
        limit: paginationModel.pageSize,
        filters: {
            searchKey: paginationModel.filters.searchKey,
            sortBy: paginationModel.filters.sortBy,
            sortType: paginationModel.filters.sortType,
            filterOptions: paginationModel.filters.filterOptions || []
        }
        });
        if (listResponse.success=='1') {
            setList(listResponse.data.list);
            setAllRowCount(listResponse.data.totalItems);
        } 
        else {
        //   Swal.fire('Request failed','','error')
        }
    } catch (error) {
        Swal.fire(error.message,'','error')
    }
    setLoading(false)
    };
    
    /************************  Manage Use Effect **************************** */
    useEffect(() => {
    fetchBannerList();
    }, [paginationModel]);

    const handleStatusChange = async (data,bannerId) => {
      // console.log ("required customer data for status change:",data);
      const result = await Swal.fire({
        text: "Do you want to Change Banner Status now?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Change now!',
        cancelButtonText: 'No, Cancel',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCloseButton: false,
      });
    
      if (result.isConfirmed) {
        try {
          // Show loading state
          Swal.fire({
            title: 'Processing...',
            text: 'Please wait while we update the banner status',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
    
          // Make the API call
          const statusChangeResponse = await BannerServices.changeStatus(bannerId);
          // console.log("customer account status change response:", statusChangeResponse);
    
          // Close loading dialog and show success/error message
          if (statusChangeResponse.success == '1') {
            await fetchBannerList();
            await Swal.fire({
              icon: 'success',
              title: 'Success!',
              text: statusChangeResponse.message || 'Banner Status updated successfully',
              timer: 1500
            });
            
            return true;
          } else {
            await Swal.fire({
              icon: 'error',
              title: 'Error!',
              text: statusChangeResponse.message || 'Failed to update banner status'
            });
            return false;
          }
    
        } catch (error) {
          // console.error("Error changing customer account status:", error);
          await Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'An error occurred while updating the banner status'
          });
          return false;
        }
      } else {
        return false;
      }
    };

  /************************  Action Handler Related table row **************************** */   
  const handlePaginationChange = (newPagination) => {
      setPaginationModel({
          ...paginationModel,
          page: newPagination.page,
          pageSize: newPagination.pageSize
      });
  }
  

  /******************* Sorting model  ******************************/
  const [sortModel, setSortModel] = useState([
    {
      field: paginationModel.filters.sortBy,
      sort: paginationModel.filters.sortType,
    },
  ]);

  const handleSortingChange = (newSortModel)=>{
    console.log("new sort model",newSortModel);
    if (newSortModel && newSortModel.length > 0) {
      setSortModel(newSortModel);
      setPaginationModel(prev => ({
        ...prev,
        filters: {
          ...prev.filters,
          sortBy: newSortModel[0].field,
          sortType: newSortModel[0].sort
        }
      }));
    }
    // else{
    //   setSortModel([{
    //     field: 'createdAt',
    //     sort: 'asc',
    //   }]);
    //   setPaginationModel(prev => ({
    //     ...prev,
    //     filters: {
    //       ...prev.filters,
    //       sortBy: 'createdAt',
    //       sortType: 'asc'
    //     }
    //   }));
    // }
  }
  return (
    <ExpertBannerContext.Provider value={{list,setList,fetchBannerList,loading,setLoading,allRowCount,paginationModel,handlePaginationChange,handleSortingChange,sortModel,handleStatusChange}}>
        {loading && <Loading/>}
        <Grid container spacing={2}>
        <Grid item xs={12} sm={10}>
            <SliderList />
        </Grid>
        <Grid item xs={12} sm={2}>
            <ExpertAppSlider/>
        </Grid>
        </Grid>
    </ExpertBannerContext.Provider>
  )
}

export default ExpertBanners
export {ExpertBannerContext}
